import React, { Component } from "react";
import * as PropTypes from "prop-types";
import axios from "axios";
import { Button, DatePicker, Form, Modal, Spin, Radio, Select } from "antd";

import moment from "moment";

import { API_ERRO_TYPE_CANCEL } from "./../../config/general";

import { webserviceService, resalesService, companiesService } from "./../../redux/services";

import {
	DateWithEndPickerMask,
} from "./../../components";

class Filters extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.filtersClean = {
			is_active: null,
			empresa_uuid: null,
		};

		this.state = {
			filters: {
				...this.filtersClean,
			},
			companiesIsLoading: false,
			companies: [],
		};
	}

	fetchTenants = (value) => {
		if (this._axiosCancelTenantsToken) {
			this._axiosCancelTenantsToken.cancel("Only one request allowed at a time.");
		}

		this._axiosCancelTenantsToken = axios.CancelToken.source();

		if (!value.trim().length) {
			this.setState({
				companiesIsLoading: false,
				companies: [],
			});

			return false;
		}

		this.setState({
			companiesIsLoading: true,
		});

		companiesService.getAll({
			search: value,
			// orderBy: "name:asc",
			cancelToken: this._axiosCancelTenantsToken.token,
		})
			.then((response) => {
				this.setState({
					companiesIsLoading: false,
					companies: response.data.data,
				});

			})
			.catch((data) => {
				if (data.error_type === API_ERRO_TYPE_CANCEL) return null;

				this.setState({
					companiesIsLoading: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	onOpen = (filters) => {
		this.setState({
			filters: filters,
		});
	};

	cleanFilters = () => {
		this.setState({
			filters: this.filtersClean,
		}, () => {
			// Callback
			this.props.onComplete({ ...this.state.filters });
		});
	};

	onClose = () => {
		// Callback
		this.props.onClose();
	};

	filtersOnConfirm = () => {
		// Callback
		this.props.onComplete({ ...this.state.filters });
	};

	setFilter = (name, value) => {
		this.setState(state => ({
			filters: {
				...state.filters,
				[name]: value,
			}
		}));
	};

	render() {
		const { visible } = this.props;

		const { filters, companies, companiesIsLoading, resales, states, statesIsLoading } = this.state;

		return (
			<Modal
				visible={visible}
				title="Filtrar"
				centered={true}
				destroyOnClose={true}
				maskClosable={true}
				width={900}
				okText="Aplicar"
				onCancel={this.onClose}
				onOk={this.filtersOnConfirm}
				className="modal-filters"
				footer={[
					<Button key="back" type="link" onClick={this.cleanFilters}>Excluir filtros</Button>,
					<Button key="submit" type="primary" onClick={this.filtersOnConfirm}>Aplicar</Button>,
				]}>
				{/* <div className="filter-group">
					<div className="filter-group-title">
						<h3>Estado</h3>
					</div>
					<div className="filter-group-filters" style={{ paddingBottom: 0 }}>
						<Form.Item>
							<Select
								filterOption={false}
								allowClear
								placeholder="Pesquise o estado"
								notFoundContent={statesIsLoading ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : null}
								onSearch={this.fetchStates}
								onChange={(value) => this.setFilter("state_id", value ?? null)}
								showSearch
								value={this.state.filters.state_id}>
								{states.map((item, index) => (
									<Select.Option key={index} value={item.uuid}>
										{item.name}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					</div>
				</div> */}
				<div className="filter-group">
					<div className="filter-group-title" style={{ paddingTop: 0 }}>
						<h3>Status</h3>
					</div>
					<div className="filter-group-filters" style={{ paddingBottom: 5 }}>
						<div className="filter-group-radios">
							<div className="filter-group-radio">
								<Radio onChange={(e) => this.setFilter("is_active", null)} checked={filters.is_active === null}>Todos</Radio>
							</div>
							<div className="filter-group-radio">
								<Radio onChange={(e) => this.setFilter("is_active", 1)} checked={filters.is_active === 1}>Ativo</Radio>
							</div>
							<div className="filter-group-radio">
								<Radio onChange={(e) => this.setFilter("is_active", 0)} checked={filters.is_active === 0}>Inativo</Radio>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		)
	}
}

export default Filters;
